import React, { useCallback, useEffect, useRef, useState } from "react";
import * as createjs from "createjs-module";
import SignPopup from "./SignPopup";
import GoogleFontLoader from "react-google-font-loader";
import { Document, pdfjs, Page, PageProps } from "react-pdf";
import { Container } from "@mui/system";
import {
  Grid,
  Paper,
  Stack,
  TextField,
  Typography,
  Button,
  ButtonGroup,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Box,
  Backdrop,
} from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import { styled } from "@mui/material/styles";
import Draggable from "react-draggable";
import axios, { AxiosResponse } from "axios";
import { useParams } from "react-router-dom";
import { get, set } from "lodash-es";
import ThankYou from "./ThankYou";
import Swal from "sweetalert2";
import RenderPdfPage from "./PDF/RenderPdfPage";
import PageWithObserver from "./PDF/PageWithObserver";
import SendDocDialog from "./Esign/sendEsignDoc";
import ManageDocuments from "./Manage/ManageDocs";
import { uploadFileToBlob } from "./blobUploadService";
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

const signFonts = [
  { font: "Alex Brush" },
  { font: "Caveat" },
  { font: "Dancing Script" },
  { font: "Great Vibes" },
  { font: "Inspiration" },
  { font: "Parisienne" },
  { font: "Sacramento" },
  { font: "Tangerine" },
  { font: "Yellowtail" },
  { font: "Square Peg" },
  { font: "Dancing Script" },
];

let stage = new createjs.Stage("demoCanvas");

const url = "http://www.pdf995.com/samples/pdf.pdf";

const objectJson = [
  {
    id: 1,
    name: "amir khan",
    font: "Square Peg",
    type: "sign",
    x: 300,
    y: 300,
    size: 40,
  },
  // {
  //   id: 2,
  //   date: new Date().toLocaleDateString(),
  //   type: "date",
  //   x: 200,
  //   y: 200,
  // },
];

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(2),
  paddingLeft: theme.spacing(4),
  textAlign: "left",
  color: theme.palette.text.secondary,
}));

//let portalBaseUrl = "https://localhost:44334";//process.env.REACT_APP_API_PORTAL_BASEURL;
let portalBaseUrl =
  process.env.REACT_APP_API_PORTAL_BASEURL || "https://localhost:44334";

export default function PdfSign(props) {
  const [open, setOpen] = React.useState(false);
  const [sendDocOpen, setSendDocOpen] = React.useState(false);
  const [signStatus, setSignStatus] = useState(false);
  const [checkStatus, setCheckStatus] = useState(false);
  const [proccedStatus, setProccedStatus] = useState(true);
  const [signObject, setSignObject] = useState({});
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [file, setFile] = useState(null);
  const [fileName, setFileName] = useState(null);
  const [fileBase64, setFileBase64] = useState("");
  const [signJson, setSignJson] = useState([]);
  const [pdfImage, setPdfImage] = useState("");
  const [pdfCanvasHeight, setPdfCanvasHeight] = useState(0);
  const [pdfCanvasWidth, setPdfCanvasWidth] = useState(0);
  const [selectedObj, setSelectedObj] = useState({});
  const [signFile, setSignFile] = useState("");
  const ref = React.useRef();
  const params = useParams();
  const [baseUrl1, setBaseUrl] = useState(portalBaseUrl);
  const [docId, setDocId] = useState(0);
  const [docName, setDocName] = useState(0);
  const [docSignData, setDocSignData] = useState(null);
  const [appCiid, setAppCiid] = useState(0);
  const [docSenderId, setDocSenderId] = useState(0);
  const [senderClientId, setSenderClientId] = useState(0);
  const [signType, setSignType] = useState("sender");
  const [visiblePages, setVisiblePages] = useState({});
  const [signDocType, setSignDocType] = useState("");
  const [signerUser, setSignerUser] = useState(null);
  const [signerIp, setSignerIp] = useState("");
  const [alertMsg, setAlertMsg] = useState("");
  const [closedBtnStatus, setClosedBtnStatus] = useState(false);

  useEffect(() => {
    const id = window.location?.pathname?.split("/");
    if (id) {
      loadSignDoc(id);
    }
  }, []);

  const loadSignDoc = async (id) => {
    const ids = id.filter((x) => x !== "");
    if (ids.length > 0) {
      const docParam = ids[0].split("_");
      let docId = 0;
      let ciid = 0;
      let senderId = 0;
      if (docParam.length > 0) {
        docId = docParam[0];
        setDocId(docId);
      }
      if (docParam.length > 1) {
        ciid = docParam[1];
        setAppCiid(ciid);
      }
      if (docParam.length > 2) {
        senderId = docParam[2];
        setDocSenderId(senderId);
      }

      if (docParam.length > 3) {
        setSenderClientId(docParam[3]);
      }

      if (docParam.length > 4) {
        setDocName(decodeURIComponent(docParam[4]));
      }

      if (docParam.length === 4) {
        setSignType("signer");
      }

      let signPoOrder = "";
      if (docParam.length > 5) {
        setSignDocType(docParam[5]);
        signPoOrder = docParam[5];
      }

      if (docParam.length > 4) {
        setSignType("sender");
        setProccedStatus(false);
      }

      if (
        signPoOrder === "partner" ||
        signPoOrder === "contractPartner" ||
        signPoOrder === "esignPartner"
      ) {
        setSignType("signer");
      }

      let docUrl = "/api/Portal/GetDocusignDocumentData?id=" + docId;
      docUrl = "/api/Portal/GetSignerDoc?docId=" + docId + "&ciid=" + ciid;

      if (
        signPoOrder === "ipcs" ||
        signPoOrder === "partner" ||
        signPoOrder === "ipcsSigned"
      )
        docUrl =
          "/api/Portal/GetPoSignerDoc?poId=" + docId + "&type=" + signPoOrder;

      if (signPoOrder === "contractSigned" || signPoOrder === "contractPartner")
        docUrl =
          "/api/Portal/GetContractSignerDoc?docId=" + docId + "&ciid=" + ciid;

      const { data } = await axios.get(portalBaseUrl + docUrl);

      let pdfBlob = null;
      let loadedFileName =
        docParam.length > 4 ? decodeURIComponent(docParam[4]) : "document.pdf";

      if (data?.uploadUrl) {
        const blobResp = await axios.get(data.uploadUrl, {
          responseType: "blob",
        });
        pdfBlob = blobResp.data;
        loadedFileName = data.blobName || loadedFileName;
      } else if (data instanceof Blob) {
        pdfBlob = data;
      } else {
        const blobResp = await axios.get(portalBaseUrl + docUrl, {
          responseType: "blob",
        });
        pdfBlob = blobResp.data;
      }

      if (pdfBlob?.size > 0) {
        const loadedFile = new File([pdfBlob], loadedFileName, {
          type: "application/pdf",
        });

        setFile(loadedFile);
        setSignFile(loadedFile);
        setFileName(loadedFile);

        if (
          docParam.length === 4 ||
          signPoOrder === "partner" ||
          signPoOrder === "contractPartner" ||
          signPoOrder === "esignPartner"
        )
          loadSignData(docId, docParam[3], ciid);

        if (parseInt(senderId) > 0) {
          const { data: signerUser } = await axios.get(
            portalBaseUrl + "/api/Portal/GetSignerDetails?id=" + senderId,
          );
          setSignerUser(signerUser);
        }
      }
    }
  };

  const handleClickOpen = (event) => {
    const obj = signJson.filter((x) => x.id === event.currentTarget.id);
    if (obj.length > 0) {
      setSelectedObj(obj[0]);
      setOpen(true);
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    if (!signStatus && signJson.length > 0) {
      const pgSignJson = signJson.filter((x) => x.pgNum === pageNumber);
      stage = new createjs.Stage(`demoCanvas${pageNumber}`);
      stage.enableMouseOver(20); // 20fps for mouse over
      createjs.Ticker.framerate = 60;
      createjs.Ticker.addEventListener("tick", stage);
      renderSignPoint(pgSignJson);
    }
    // Cleanup
    return () => {
      createjs.Ticker.removeEventListener("tick", stage);
      stage.removeAllChildren();
      stage.update();
    };
  }, [signJson, pageNumber]);

  const renderSignPoint = (signArray) => {
    signArray.map((item) => {
      if (item.type === "check") {
        addSignReadOnlyCheckBox(item);
      }
      if (item.type === "ini") {
        addSignReadOnlyInitial(item);
      }
      if (signType === "signer") {
        if (item.type === "sign") addSignReadOnlyContainer(item);
        if (item.type === "date") addDateReadOnlySigned(item);
        if (item.type === "text") addSignReadOnlyText(item);
      } else {
        if (item.type === "sign") addSignContainer(item);
        if (item.type === "date") addDateSigned(item);
        if (item.type === "text") addSignText(item);
      }
    });
  };

  const addSignContainer = (signObj) => {
    console.log(signObj);
    // Background Rectangle
    var containerBg = new createjs.Shape();
    containerBg.name = "background";
    containerBg.graphics
      .setStrokeStyle(1)
      .beginFill("rgba(255, 244, 189, 0.5)")
      .beginStroke("#ccc")
      .drawRoundRect(
        -(signObj.name.length / 2) * (signObj.size / 2) - 5,
        -signObj.size / 2 - 10,
        (signObj.name.length / 2) * signObj.size + 10,
        signObj.size + 15,
        0,
      );
    var container = new createjs.Container().set({
      x: signObj.x,
      y: signObj.y,
    });
    container.id = signObj.id;
    container.type = signObj.type;

    // Label (Text)
    var label = new createjs.Text(
      signObj.name,
      `${signObj.size}px ${signObj.font}`,
      signObj.color,
    );

    label.name = "label";
    label.textAlign = "center";
    label.textBaseline = "middle";

    // Edit Icon
    var editIcon = new createjs.Text("", "16px FontAwesome", "black");
    editIcon.name = "label";
    editIcon.textAlign = "center";
    editIcon.textBaseline = "middle";
    editIcon.x = -containerBg.graphics.command.x - 10;
    editIcon.y = containerBg.graphics.command.y - 12;
    editIcon.id = signObj.id;
    editIcon.type = signObj.type;
    editIcon.cursor = "pointer";
    editIcon.on("click", handleClickOpen);

    // Delete Icon
    var delIcon = new createjs.Text("", "18px FontAwesome", "red");
    delIcon.name = "label";
    delIcon.textAlign = "center";
    delIcon.textBaseline = "middle";
    delIcon.x = -containerBg.graphics.command.x + 10;
    delIcon.y = containerBg.graphics.command.y - 10;
    delIcon.id = signObj.id;
    delIcon.type = signObj.type;
    delIcon.cursor = "pointer";
    delIcon.on("click", handleDeletObject);

    // Resize Handle
    const resizeHandle = new createjs.Shape();
    resizeHandle.graphics.beginFill("gray").drawCircle(0, 0, 5);
    const bgWidth = (signObj.name.length / 2) * signObj.size + 10;
    const bgHeight = signObj.size + 15;
    resizeHandle.x = bgWidth / 2;
    resizeHandle.y = bgHeight / 2;
    resizeHandle.name = "resizer";
    resizeHandle.cursor = "nwse-resize";
    resizeHandle.on("pressmove", function (evt) {
      evt.stopPropagation();
      handleResize(evt, container, label, containerBg);
    });

    // Add children to container
    container.addChild(containerBg, label, editIcon, resizeHandle, delIcon);
    container.on("pressmove", handleDrag);
    stage.addChild(container);
    //stage.update();
  };

  const handleResize = (evt, container, label, containerBg) => {
    const mouse = container.globalToLocal(evt.stageX, evt.stageY);
    const currentFontSize = parseFloat(label.font.split("px")[0]);
    const deltaX = mouse.x - (container.lastMouseX || 0);
    const sensitivity = 0.5;

    let newFontSize = currentFontSize;

    if (Math.abs(deltaX) > sensitivity) {
      newFontSize += deltaX > 0 ? 0.5 : -0.5;
      newFontSize = Math.max(10, Math.round(newFontSize * 10) / 10);
      container.lastMouseX = mouse.x;
    }

    const fontFamily = label.font.split(" ").slice(1).join(" ");
    label.font = `${newFontSize}px ${fontFamily}`;

    // Update the state immutably
    setSignJson((prevSignJson) => {
      return prevSignJson.map((sign) => {
        if (sign.id === container.id) {
          return { ...sign, size: newFontSize };
        }
        return sign;
      });
    });

    //stage.update();
  };

  const addDateSigned = (dtObj) => {
    var containerBg = new createjs.Shape();
    containerBg.name = "background";
    containerBg.graphics
      .setStrokeStyle(1)
      .beginFill("rgba(255, 244, 189, 0.5)")
      .beginStroke("#ccc")
      .drawRoundRect(
        -(dtObj.date.length / 2) * (20 / 2) - 5,
        -20 / 2 - 10,
        (dtObj.date.length / 2) * 20 + 10,
        20 + 15,
        0,
      );

    var c = new createjs.Container().set({ x: dtObj.x, y: dtObj.y });
    c.id = dtObj.id;
    c.type = dtObj.type;
    var label = new createjs.Text(`${dtObj.date}`, `20px robot`, "black");
    label.name = "label";
    label.textAlign = "center";
    label.textBaseline = "middle";

    // Delete Icon
    var delIcon = new createjs.Text("", "18px FontAwesome", "red");
    delIcon.name = "label";
    delIcon.textAlign = "center";
    delIcon.textBaseline = "middle";
    delIcon.x = -containerBg.graphics.command.x + 10;
    delIcon.y = containerBg.graphics.command.y - 10;
    delIcon.id = dtObj.id;
    delIcon.type = dtObj.type;
    delIcon.cursor = "pointer";
    delIcon.on("click", handleDeletObject);

    // Edit Icon
    var editIcon = new createjs.Text("", "16px FontAwesome", "black");
    editIcon.name = "label";
    editIcon.textAlign = "center";
    editIcon.textBaseline = "middle";
    editIcon.x = -containerBg.graphics.command.x - 10;
    editIcon.y = containerBg.graphics.command.y - 12;
    editIcon.id = dtObj.id;
    editIcon.type = "date";
    editIcon.cursor = "pointer";
    editIcon.on("click", handleClickOpen);

    c.addChild(containerBg, label, delIcon, editIcon);
    c.on("pressmove", handleDrag);
    stage.addChild(c);
  };

  const handleDeletObject = (event) => {
    const { id } = event.currentTarget;
    let updatedJson = [...signJson.filter((x) => x.id !== id)];
    setSignJson(updatedJson);
  };
  const updateObjectPosition = (event) => {
    const { currentTarget: obj } = event;
    //let updatedJson = [...signJson];
    const findObj = signJson.filter((x) => x.id == obj.id);
    if (findObj.length > 0) {
      //const currentObj = { ...findObj[0] };
      //const index = updatedJson.findIndex(x => x.id === obj.id);
      findObj[0].x = parseInt(obj.x);
      findObj[0].y = parseInt(obj.y);
      //updatedJson[index] = currentObj;
      //setSignJson(updatedJson);
      // renderSignPoint(updatedJson);
      stage.update(event);
    }
  };

  const handleDateTimeAdd = (event) => {
    const objId = Math.max(...signJson.map((x) => x.id)) + 1;
    let updatedJson = [...signJson];
    const dateObj = {
      id: objId,
      date: new Date().toLocaleDateString(),
      type: "date",
      x: 200,
      y: 200,
    };
    updatedJson.push(dateObj);
    stage.update(event);
    //setSignJson(updatedJson);
  };
  const handleDrag = (evt) => {
    evt.currentTarget.x = stage.mouseX;
    evt.currentTarget.y = stage.mouseY;
    updateObjectPosition(evt);
  };

  const handleSaveSign = (signObj) => {
    const index = signJson.findIndex((x) => x.id === signObj.id);
    let newList = [...signJson];
    // const newObj = {
    //   id: signObj.id,
    //   type: signObj.type,
    //   x: signObj.x,
    //   y: signObj.y,
    //   name: signObj.name,
    //   font: signObj.font,
    //   size: signObj.fontSize,
    // };
    // newList[index] = newObj;
    const nobj = {
      ...signJson[index],
      name: signObj.name,
      font: signObj.font,
      size: signObj.fontSize,
      color: signObj.fontColor,
    };
    newList[index] = nobj;
    setSignJson(newList);
    setOpen(false);
  };

  const handleSaveDate = (dtObj) => {
    const index = signJson.findIndex((x) => x.id === dtObj.id);
    let newList = [...signJson];
    const nobj = {
      ...signJson[index],
      date: dtObj.date,
    };
    newList[index] = nobj;
    setSignJson(newList);
    setOpen(false);
  };

  function onDocumentLoadSuccess(pdf) {
    //console.log(pdf);
    //setNumPages(numPages);
    //setPageNumber(1);
  }

  const handleItemDrop = (event, obj) => {
    let objId = 1;
    if (signJson.length > 0) {
      objId = signJson[signJson.length - 1].id + 1;
    }

    let x = 0;
    let y = event.clientY - 60;
    if (event.clientX > 810 && pdfCanvasWidth > 700) {
      x += event.clientX - (pdfCanvasWidth - 60);
    }

    if (event.clientX > 810 && pdfCanvasWidth < 700) {
      x += event.clientX - (pdfCanvasWidth + (810 - pdfCanvasWidth));
    }

    if (event.clientX > 1320) {
      x = pdfCanvasWidth - 50;
    }

    let lbl = "Sign Here";
    if (obj.type === "ini") lbl = "Initial";

    if (obj.type === "text") lbl = "Enter Text";

    let newObj = {
      id: objId,
      name: lbl,
      font: "Roboto-Regular.ttf",
      type: obj.type,
      x: x,
      y: y,
      size: 16,
      pgNum: pageNumber,
      chkStatus: false,
    };

    if (obj.type === "date") {
      const curDt = new Date();
      let dt = "";
      let dd = curDt.getDate();
      if (dd < 10) dd = "0" + dd;
      let mm = curDt.getMonth() + 1;
      if (mm < 10) mm = "0" + mm;
      const yy = curDt.getFullYear();
      dt = mm + "-" + dd + "-" + yy;

      newObj = {
        id: objId,
        name: "Current Date",
        font: "Roboto",
        date: dt,
        type: obj.type,
        x: x,
        y: y,
        size: 12,
        pgNum: pageNumber,
      };
    }

    const newUpdated = [...signJson, newObj];
    //console.log(newUpdated, "new object");
    setSignJson(newUpdated);
    //renderSignPoint(newUpdated);
    //setSignJson(newUpdated);
  };

  const updateSaveProgress = (
    percent = 0,
    stageText = "Uploading signed PDF...",
  ) => {
    const htmlContainer = Swal.getHtmlContainer();
    if (!htmlContainer) return;
    const safePercent = Math.max(0, Math.min(100, percent));
    const stageEl = htmlContainer.querySelector("#save-stage-text");
    const progressText = htmlContainer.querySelector("#save-progress-text");
    const progressBar = htmlContainer.querySelector("#save-progress-bar");

    if (stageEl) {
      stageEl.textContent = stageText;
    }

    if (progressText) {
      progressText.textContent = `Upload progress: ${safePercent}%`;
    }

    if (progressBar) {
      progressBar.style.width = `${safePercent}%`;
      progressBar.setAttribute("aria-valuenow", `${safePercent}`);
    }
  };

  const handleSavePdf = async (e) => {
    const chkSignName = signJson.filter(
      (x) => x.type === "sign" && (x.name === "" || x.name === "Sign Here"),
    );

    if (chkSignName.length > 0)
      return Swal.fire(
        "Please Sign Document",
        "You haven't signed the document yet.",
        "error",
      );

    Swal.fire({
      html: `
        <div id="save-stage-text" style="margin-top:8px;">Preparing document...</div>
        <div id="save-progress-text" style="margin-top:8px;">Upload progress: 0%</div>
        <div style="margin-top:10px;height:10px;width:100%;background:#e5e7eb;border-radius:999px;overflow:hidden;">
          <div id="save-progress-bar" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="0" style="height:100%;width:0%;background:#1976d2;transition:width .2s ease;"></div>
        </div>
      `,
      allowOutsideClick: false,
      allowEscapeKey: false,
      didOpen: () => {
        Swal.showLoading();
        updateSaveProgress(0, "Preparing document...");
      },
    });

    try {
      await saveSignedPdf(e, updateSaveProgress);
    } catch {
      // Error modal is handled in saveSignedPdf catch block.
    }
  };

  const saveSignedPdf = async (e, onProgress) => {
    const allSignData = [];

    signJson.forEach((item) => {
      let txt = item.name;

      if (item.type === "date") {
        txt = item.date;
      }

      // Fallback height for fields if not provided
      const defaultHeight = item.size ? item.size * 1.5 : 20;
      const boxHeight = item.height || defaultHeight;
      const boxWidth = item.width || 150;

      const signData = {
        id: item.id,
        text: txt,
        font: item.font, // e.g., "SquarePeg-Regular.TTF"
        type: item.type,
        lowerLeftX: item.x,
        lowerLeftY: item.y,
        upperRightX: item.x + boxWidth,
        upperRightY: item.y + boxHeight,
        fontSize: item.size,
        page: item.pgNum,
      };
      allSignData.push(signData);
    });

    // Signer info handling
    let signerInfo = {
      name: "Comming Soon...",
      email: "Comming Soon...",
      ip: "Comming Soon...",
      address: "Comming Soon...",
      address1: "Comming Soon...",
    };

    if (signerUser) {
      let name = "";
      if (signerUser.performername) name = signerUser.performername + " ";
      if (signerUser.lastName) name += signerUser.lastName;
      signerInfo.name = name;
      signerInfo.email = signerUser.performeremail;
      signerInfo.ip = signerIp;
    }

    const url = process.env.REACT_APP_API_BASEURL || "http://localhost:7095";
    const baseUrl1 = `${url}/api/signer/SignDocument`;

    const frmData = new FormData();
    frmData.append("pdf", fileName);
    frmData.append("SignJson", JSON.stringify(allSignData));
    frmData.append("signerCount", 1);
    frmData.append("signerInfo", JSON.stringify(signerInfo));

    try {
      if (onProgress) onProgress(0, "Applying signatures...");
      const response = await axios.post(baseUrl1, frmData, {
        responseType: "blob",
      });

      //Swal.close();
      //setAlertMsg("Saved successfully.");

      if (docId > 0 && response?.data?.size > 0) {
        const frmDt = new FormData();
        //frmDt.append("signedFile", response.data);
        frmDt.append("fileSize", response?.data?.size || 0);
        frmDt.append("id", docId);
        frmDt.append("type", signDocType);
        frmDt.append("ciid", appCiid);
        //const repo = await axios.post(portalBaseUrl + "/api/Portal/SaveSignedDocument", frmDt);
        let portalApi = portalBaseUrl + "/api/Portal/SaveSignerSignedDocument";

        if (signDocType === "ipcs" || signDocType === "partner")
          portalApi = portalBaseUrl + "/api/Portal/SavePoSignedDocument";

        if (signDocType === "contract")
          portalApi = portalBaseUrl + "/api/Portal/SaveContractSignedDocument";

        if (signDocType === "contractPartner")
          portalApi =
            portalBaseUrl + "/api/Portal/SavePartnerContractSignedDocument";

        const repo = await axios.post(portalApi, frmDt);
        if (repo?.data?.uploadUrl) {
          setClosedBtnStatus(true);
          if (onProgress) onProgress(0, "Uploading signed PDF...");
          await uploadFileToBlob(
            response.data,
            repo.data?.uploadUrl,
            (progress) => {
              console.log(`Upload progress: ${progress}%`);
              if (onProgress) onProgress(progress, "Uploading signed PDF...");
            },
          );
          if (onProgress) onProgress(100, "Finalizing...");
          setClosedBtnStatus(false);
        }
        Swal.close();
        setSignStatus(true);
      }
    } catch (err) {
      //console.error("PDF signing failed:", err);
      Swal.close();
      Swal.fire("Error", "Failed to save signed PDF", "error");
      throw err;
    }
  };

  const handleWindowClose = (e) => {
    window.opener = null;
    window.open("about:blank", "_self", "");
    window.close();
  };

  const handleAddSignature = () => {
    const event = { clientX: 600, clientY: 440 };
    const obj = { type: "sign" };
    handleItemDrop(event, obj);
  };

  const handlePDFLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
    setPageNumber(1);
  };

  const handlePageChange = (num) => {
    setPageNumber(num);
  };

  const getPageDocumentPage = () => {
    const buttons = [];
    for (let index = 1; index <= numPages; index++) {
      buttons.push(
        <Button
          key={index}
          sx={{ mb: 1 }}
          color={`${pageNumber === index ? "primary" : "inherit"}`}
          variant="contained"
          onClick={() => handlePageChange(index)}
        >
          Page {index}
        </Button>,
      );
    }
    return buttons;
  };

  const handleSaveSignData = async (e) => {
    Swal.fire({
      //title: "Save",
      html: "Sending your esign document.",
      //timer: 2000,
      //timerProgressBar: true,
      allowOutsideClick: false,
      didOpen: () => {
        sendSignDoc(e);
        Swal.showLoading();
      },
    }).then((result) => {
      if (result.dismiss === Swal.DismissReason.timer) {
        console.log("I was closed by the timer");
      }
    });
  };

  const sendSignDoc = async (e) => {
    //const url = "http://localhost:7095";//process.env.REACT_APP_API_BASEURL;
    const url = process.env.REACT_APP_API_BASEURL || "http://localhost:7095";
    let baseUrl1 = url + "/api/signer/SaveSignDocument";
    const frmData = new FormData();
    frmData.append("id", docId);
    frmData.append("fileName", docName);
    frmData.append("signData", JSON.stringify(signJson));
    frmData.append("appCiid", appCiid);
    frmData.append("clientId", senderClientId);
    frmData.append("senderId", docSenderId);
    const response = await axios.post(baseUrl1, frmData);
    if (response?.status === 200) {
      Swal.close();
      setSignStatus(true);
      // Swal.fire({
      //   title: "Success",
      //   text: "Sent successfully.",
      // })
      setAlertMsg("Sent successfully.");

      const frmDt = new FormData();
      frmDt.append("ids", [docId]);
      frmDt.append("userId", docSenderId);
      frmDt.append("ciid", appCiid);

      let apiUrl = portalBaseUrl + "/api/ReviewForm/SendeSignDocument";
      if (
        signDocType === "ipcs" ||
        signDocType === "partner" ||
        signDocType === "ipcsSigned"
      )
        apiUrl = portalBaseUrl + "/api/ReviewForm/SendPoSignDocument";

      if (signDocType === "contractSigned")
        apiUrl = portalBaseUrl + "/api/ReviewForm/SendContractSignDocument";

      const repo = await axios.post(apiUrl, frmDt);
      //handleWindowClose(e);
    }
  };

  useEffect(() => {
    if (signType) {
      // if (signType === "signer")
      //   loadSignData(docId, senderClientId);
    }
  }, [signType]);

  const loadSignData = async (id, cid, appId) => {
    //const url = "http://localhost:7095";//process.env.REACT_APP_API_BASEURL;
    const url = process.env.REACT_APP_API_BASEURL || "http://localhost:7095";
    let baseUrl1 = url + "/api/signer/GetDocumentSignData";
    const resp = await axios.get(
      baseUrl1 + "?docId=" + id + "&clientId=" + cid + "&appId=" + appId,
    );
    if (resp?.data) {
      setSignJson(JSON.parse(resp.data.docSignData));
    }
  };

  const addSignReadOnlyContainer = (signObj) => {
    var containerBg = new createjs.Shape();
    containerBg.name = "background";
    containerBg.graphics
      .setStrokeStyle(1)
      .beginFill("rgba(255, 244, 189, 0.5)")
      .beginStroke("#ccc")
      .drawRoundRect(
        -(signObj.name.length / 2) * (signObj.size / 2) - 5,
        -signObj.size / 2 - 10,
        (signObj.name.length / 2) * signObj.size + 10,
        signObj.size + 15,
        0,
      );
    var container = new createjs.Container().set({
      x: signObj.x,
      y: signObj.y,
    });
    container.id = signObj.id;
    container.type = signObj.type;
    var label = new createjs.Text(
      signObj.name,
      `${signObj.size}px ${signObj.font}`,
      "black",
    );

    label.name = "label";
    label.textAlign = "center";
    label.textBaseline = "middle";

    container.addChild(containerBg, label);
    container.cursor = "pointer";
    container.on("dblclick", handleClickOpen);
    stage.addChild(container);
    //stage.update();
  };

  const addDateReadOnlySigned = (dtObj) => {
    var c = new createjs.Container().set({ x: dtObj.x, y: dtObj.y });
    c.id = dtObj.id;
    c.type = dtObj.type;

    const d = new Date();
    let month = d.getMonth() + 1;
    let year = d.getFullYear() + 1;
    let dt = d.getDate();

    var label = new createjs.Text(`${dtObj.date}`, `20px robot`, "black");
    label.name = "label";
    label.textAlign = "center";
    label.textBaseline = "middle";
    c.addChild(label);
    stage.addChild(c);
  };

  const addSignReadOnlyCheckBox = (signObj) => {
    var containerBg = new createjs.Shape();
    containerBg.name = "background";
    containerBg.graphics
      .beginFill("#f0f0f0")
      .beginStroke(2)
      .drawRoundRect(
        -(signObj.name.length + 5),
        -signObj.size / 2 + 10,
        16,
        15,
        0,
      );
    var container = new createjs.Container().set({
      x: signObj.x,
      y: signObj.y,
    });
    container.id = signObj.id;
    container.type = signObj.type;

    var label = new createjs.Text(
      signObj.name,
      `${signObj.size}px ${signObj.font}`,
      "black",
    );

    label.name = "label";
    label.textAlign = "center";
    label.textBaseline = "middle";

    var delIcon = new createjs.Text("", "18px FontAwesome", "red");
    delIcon.name = "label";
    delIcon.textAlign = "center";
    delIcon.textBaseline = "middle";
    delIcon.x = -containerBg.graphics.command.x;
    delIcon.y = containerBg.graphics.command.y - 4;
    delIcon.id = signObj.id;
    delIcon.type = signObj.type;
    delIcon.cursor = "pointer";
    delIcon.on("click", handleDeletObject);

    let chkBgColor = "#f0f0f0";
    let chkSize = "15px FontAwesome";
    if (signObj.chkStatus) {
      chkBgColor = "black";
      chkSize = "20px FontAwesome";
    }

    var checkIcon = new createjs.Text("", chkSize, chkBgColor);
    checkIcon.name = "label";
    checkIcon.textAlign = "center";
    checkIcon.textBaseline = "middle";
    checkIcon.x = -containerBg.graphics.command.x - 20;
    checkIcon.y = containerBg.graphics.command.y + 7;
    if (signObj.chkStatus) {
      checkIcon.x = -containerBg.graphics.command.x - 18;
      checkIcon.y = containerBg.graphics.command.y + 5;
    }

    checkIcon.id = signObj.id;
    checkIcon.type = signObj.type;
    checkIcon.cursor = "pointer";
    checkIcon.on("click", handleCheckBoxChecked);

    // if (signObj.chkStatus) container.addChild(containerBg, checkIcon, delIcon);
    // else container.addChild(containerBg, delIcon);
    container.addChild(containerBg, checkIcon, delIcon);

    container.cursor = "pointer";
    container.on("pressmove", handleDrag);
    //container.on("click", handleCheckBoxChecked);
    stage.addChild(container);
    stage.update();
  };

  const handleCheckBoxChecked = (event) => {
    const { currentTarget: obj } = event;
    const findObj = signJson.filter((x) => x.id == obj.id);
    if (findObj.length > 0) {
      if (findObj[0].type === "check") {
        const currentObj = { ...findObj[0] };
        const index = signJson.findIndex((x) => x.id === obj.id);
        if (currentObj.chkStatus) currentObj.chkStatus = false;
        else currentObj.chkStatus = true;

        const updatedJson = [...signJson];
        updatedJson[index] = currentObj;
        setSignJson(updatedJson);
        stage.update();
      }
    }
  };

  const addSignReadOnlyInitial = (signObj) => {
    var containerBg = new createjs.Shape();
    containerBg.name = "background";
    containerBg.graphics
      .setStrokeStyle(1)
      .beginFill("rgba(255, 244, 189, 0.5)")
      .beginStroke("#ccc")
      .drawRoundRect(
        -(signObj.name.length / 2) * (signObj.size / 2) - 5,
        -signObj.size / 2 - 10,
        (signObj.name.length / 2) * signObj.size + 10,
        signObj.size + 15,
        0,
      );
    var container = new createjs.Container().set({
      x: signObj.x,
      y: signObj.y,
    });
    container.id = signObj.id;
    container.type = signObj.type;
    var label = new createjs.Text(
      signObj.name,
      `${signObj.size}px ${signObj.font}`,
      "black",
    );

    label.name = "label";
    label.textAlign = "center";
    label.textBaseline = "middle";

    var delIcon = new createjs.Text("", "18px FontAwesome", "red");
    delIcon.name = "label";
    delIcon.textAlign = "center";
    delIcon.textBaseline = "middle";
    delIcon.x = -containerBg.graphics.command.x + 10;
    delIcon.y = containerBg.graphics.command.y - 10;
    delIcon.id = signObj.id;
    delIcon.type = signObj.type;
    delIcon.cursor = "pointer";
    delIcon.on("click", handleDeletObject);

    var editIcon = new createjs.Text("", "16px FontAwesome", "black");
    editIcon.name = "label";
    editIcon.textAlign = "center";
    editIcon.textBaseline = "middle";
    editIcon.x = -containerBg.graphics.command.x - 10;
    editIcon.y = containerBg.graphics.command.y - 12;
    editIcon.id = signObj.id;
    editIcon.type = signObj.type;
    editIcon.cursor = "pointer";
    editIcon.on("mouseover", () => {
      console.log("mouse over2");
    });
    editIcon.on("click", handleClickOpen);

    container.addChild(containerBg, label, delIcon, editIcon);
    container.cursor = "pointer";
    container.on("pressmove", handleDrag);
    stage.addChild(container);
    stage.update();
  };

  const addSignReadOnlyText = (signObj) => {
    console.log(signObj, "text obj");
    var container = new createjs.Container().set({
      x: signObj.x,
      y: signObj.y,
    });
    container.id = signObj.id;
    container.type = signObj.type;

    // Create text label first
    var label = new createjs.Text(
      signObj.name,
      `${signObj.size}px Open Sans`,
      `black`,
    );

    label.name = "label";
    label.textAlign = "center";
    label.textBaseline = "middle";

    // Measure the label size
    var textWidth = label.getMeasuredWidth();
    var textHeight = label.getMeasuredLineHeight();

    // Padding around text
    var paddingX = 12;
    var paddingY = 10;

    // Draw background based on measured text
    var containerBg = new createjs.Shape();
    containerBg.name = "background";
    containerBg.graphics
      .setStrokeStyle(1)
      .beginFill("rgba(255, 244, 189, 0.5)")
      .beginStroke("#ccc")
      .drawRoundRect(
        -textWidth / 2 - paddingX,
        -textHeight / 2 - paddingY,
        textWidth + paddingX * 2,
        textHeight + paddingY * 2,
        0,
      );

    // Delete icon
    var delIcon = new createjs.Text("", "18px FontAwesome", "red");
    delIcon.name = "deleteIcon";
    delIcon.textAlign = "center";
    delIcon.textBaseline = "middle";
    delIcon.x = textWidth / 2 + paddingX + 9; // right edge
    delIcon.y = -textHeight / 2 - paddingY - 8; // top edge
    delIcon.id = signObj.id;
    delIcon.type = signObj.type;
    delIcon.cursor = "pointer";
    //delIcon.on("click", handleDeletObject);

    // Edit icon
    var editIcon = new createjs.Text("", "16px FontAwesome", "black");
    editIcon.name = "editIcon";
    editIcon.textAlign = "center";
    editIcon.textBaseline = "middle";
    editIcon.x = textWidth / 2 - paddingX + 10; // left edge
    editIcon.y = -textHeight / 2 - paddingY - 10; // top edge
    editIcon.id = signObj.id;
    editIcon.type = signObj.type;
    editIcon.cursor = "pointer";
    editIcon.on("mouseover", () => console.log("mouse over2"));
    //editIcon.on("click", handleClickOpen);

    // Resize Handle
    const resizeHandle = new createjs.Shape();
    resizeHandle.graphics.beginFill("gray").drawCircle(0, 0, 5);
    const bgWidth = (signObj.name.length / 2) * signObj.size + 10;
    const bgHeight = signObj.size + 15;
    resizeHandle.x = textWidth / 2 + paddingX; // right edge;
    resizeHandle.y = textHeight / 2 - paddingY + 20; // top edge;
    resizeHandle.name = "resizer";
    resizeHandle.cursor = "nwse-resize";
    resizeHandle.on("pressmove", function (evt) {
      evt.stopPropagation();
      handleResize(evt, container, label, containerBg);
    });

    // Add everything to container
    //container.addChild(containerBg, label, delIcon, resizeHandle, editIcon);
    container.addChild(containerBg, label);
    container.on("dblclick", handleClickOpen);
    //container.cursor = "pointer";
    //container.on("pressmove", handleDrag);

    stage.addChild(container);
    //stage.update();
  };

  const addSignText = (signObj) => {
    console.log(signObj, "text obj");
    var container = new createjs.Container().set({
      x: signObj.x,
      y: signObj.y,
    });
    container.id = signObj.id;
    container.type = signObj.type;

    // Create text label first
    var label = new createjs.Text(
      signObj.name,
      `${signObj.size}px Open Sans`,
      `black`,
    );

    label.name = "label";
    label.textAlign = "center";
    label.textBaseline = "middle";

    // Measure the label size
    var textWidth = label.getMeasuredWidth();
    var textHeight = label.getMeasuredLineHeight();

    // Padding around text
    var paddingX = 12;
    var paddingY = 10;

    // Draw background based on measured text
    var containerBg = new createjs.Shape();
    containerBg.name = "background";
    containerBg.graphics
      .setStrokeStyle(1)
      .beginFill("rgba(255, 244, 189, 0.5)")
      .beginStroke("#ccc")
      .drawRoundRect(
        -textWidth / 2 - paddingX,
        -textHeight / 2 - paddingY,
        textWidth + paddingX * 2,
        textHeight + paddingY * 2,
        0,
      );

    // Delete icon
    var delIcon = new createjs.Text("", "18px FontAwesome", "red");
    delIcon.name = "deleteIcon";
    delIcon.textAlign = "center";
    delIcon.textBaseline = "middle";
    delIcon.x = textWidth / 2 + paddingX + 9; // right edge
    delIcon.y = -textHeight / 2 - paddingY - 8; // top edge
    delIcon.id = signObj.id;
    delIcon.type = signObj.type;
    delIcon.cursor = "pointer";
    delIcon.on("click", handleDeletObject);

    // Edit icon
    var editIcon = new createjs.Text("", "16px FontAwesome", "black");
    editIcon.name = "editIcon";
    editIcon.textAlign = "center";
    editIcon.textBaseline = "middle";
    editIcon.x = textWidth / 2 - paddingX + 10; // left edge
    editIcon.y = -textHeight / 2 - paddingY - 10; // top edge
    editIcon.id = signObj.id;
    editIcon.type = signObj.type;
    editIcon.cursor = "pointer";
    editIcon.on("mouseover", () => console.log("mouse over2"));
    editIcon.on("click", handleClickOpen);

    // Resize Handle
    const resizeHandle = new createjs.Shape();
    resizeHandle.graphics.beginFill("gray").drawCircle(0, 0, 5);
    const bgWidth = (signObj.name.length / 2) * signObj.size + 10;
    const bgHeight = signObj.size + 15;
    resizeHandle.x = textWidth / 2 + paddingX; // right edge;
    resizeHandle.y = textHeight / 2 - paddingY + 20; // top edge;
    resizeHandle.name = "resizer";
    resizeHandle.cursor = "nwse-resize";
    resizeHandle.on("pressmove", function (evt) {
      evt.stopPropagation();
      handleResize(evt, container, label, containerBg);
    });

    // Add everything to container
    container.addChild(containerBg, label, delIcon, resizeHandle, editIcon);
    container.cursor = "pointer";
    container.on("pressmove", handleDrag);

    stage.addChild(container);
    //stage.update();
  };

  const pageRefs = useRef({});
  const onItemClick = ({ pageNumber }) =>
    pageRefs.current[pageNumber].scrollIntoView({ behavior: "smooth" });

  const setPageVisibility = useCallback(
    (pageNumber, isIntersecting, boundClient) => {
      //console.log(boundClient);
      const { width, height } = boundClient;
      setPdfCanvasHeight(height);
      setPdfCanvasWidth(width);
      setVisiblePages((prevVisiblePages) => ({
        ...prevVisiblePages,
        [pageNumber]: isIntersecting,
      }));

      if (isIntersecting) {
        setPageNumber(pageNumber);
      }
    },
    [],
  );

  const handleSendEmailSignData = () => {
    setSendDocOpen(!sendDocOpen);
  };

  return signStatus ? (
    <>
      <ThankYou
        handleWindowClose={handleWindowClose}
        message={alertMsg}
        closedBtnStatus={closedBtnStatus}
      />
    </>
  ) : (
    <>
      {proccedStatus && (
        <React.Fragment>
          <Box
            sx={{
              backgroundColor: "white",
              position: "absolute",
              zIndex: "101",
              width: "100%",
            }}
          >
            <Box textAlign="center" sx={{ pt: 1 }}>
              <Box
                component="img"
                sx={{ height: "50px" }}
                src="images/wf-logo1.png"
              ></Box>
            </Box>
            {signType !== "sender" && (
              <Box sx={{ p: 1, backgroundColor: "#b2d8ff" }}>
                <Grid container spacing={0}>
                  <Grid item xs={6}>
                    <FormGroup>
                      <FormControlLabel
                        required
                        control={
                          <Checkbox
                            onChange={(e) => setCheckStatus(e.target.checked)}
                          />
                        }
                        label="I agree to use electronic records and signatures"
                      />
                    </FormGroup>
                  </Grid>
                  <Grid item xs={6} textAlign="right">
                    <Button
                      variant="contained"
                      color="primary"
                      disabled={!checkStatus}
                      onClick={() => setProccedStatus(false)}
                    >
                      Ok Procced
                    </Button>
                  </Grid>
                </Grid>
              </Box>
            )}
          </Box>
        </React.Fragment>
      )}
      <Box textAlign="center" sx={{ pt: 1 }}>
        <Box
          component="img"
          sx={{ height: "50px" }}
          src="images/wf-logo1.png"
        ></Box>
      </Box>
      <Box
        sx={{
          p: 2,
          backgroundColor: "#b2d8ff",
          border: "1px solid #ccc",
          mb: 2,
        }}
      >
        <Grid container spacing={0}>
          <Grid item xs={6}>
            {signType !== "sender" && (
              <Typography variant="body1" sx={{ mt: 1 }}>
                Click on yellow shaded location to complete, then click 'Finish
                Button'
              </Typography>
            )}
          </Grid>
          <Grid item xs={6} textAlign="right">
            {signType === "sender" &&
              signDocType !== "ipcs" &&
              signDocType !== "contract" && (
                <>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleSaveSignData}
                    sx={{ mr: 2 }}
                  >
                    Finish & Send
                  </Button>
                </>
              )}

            {/* <Button
                  variant="contained"
                  color="primary"
                  onClick={handleSendEmailSignData}
                  sx={{ mr: 2 }}
                >
                  Send
                </Button> */}

            {(signType === "signer" ||
              (signDocType !== "ipcsSigned" &&
                signDocType !== "contractSigned" &&
                signDocType !== "esign")) && (
              <Button
                variant="contained"
                color="primary"
                onClick={handleSavePdf}
                sx={{ mr: 2 }}
              >
                Finish
              </Button>
            )}
          </Grid>
        </Grid>
      </Box>
      <Container maxWidth="xl">
        {/* <ManageDocuments /> */}

        <GoogleFontLoader fonts={signFonts} />
        <Backdrop sx={{ color: "#fff" }} open={proccedStatus}>
          {/* <CircularProgress color="inherit" /> */}
        </Backdrop>
        <Grid
          container
          spacing={0}
          sx={{ height: "100%", backgroundColor: "#f0f0f0" }}
        >
          {signType === "sender" && (
            <Grid item xs={3} sx={{ border: "1px solid #ccc", p: 3 }}>
              <Stack spacing={2}>
                <Item
                  draggable
                  onDragEnd={(e) => handleItemDrop(e, { type: "sign" })}
                >
                  <Typography
                    variant="h6"
                    component="div"
                    onClick={handleAddSignature}
                  >
                    Signature
                  </Typography>
                </Item>
                <Item
                  draggable
                  onDragEnd={(e) => handleItemDrop(e, { type: "date" })}
                >
                  <Typography variant="h6" component="div">
                    Date
                  </Typography>
                </Item>
                {/* <Item
                    draggable
                    onDragEnd={(e) => handleItemDrop(e, { type: "name" })}
                  >
                    <Typography variant="h6" component="div">
                      Name
                    </Typography>
                  </Item> */}
                <Item
                  draggable
                  onDragEnd={(e) => handleItemDrop(e, { type: "text" })}
                >
                  <Typography variant="h6" component="div">
                    Text
                  </Typography>
                </Item>
                <Item
                  draggable
                  onDragEnd={(e) => handleItemDrop(e, { type: "ini" })}
                >
                  <Typography variant="h6" component="div">
                    Initial
                  </Typography>
                </Item>
                <Item
                  draggable
                  onDragEnd={(e) => handleItemDrop(e, { type: "check" })}
                >
                  <Typography variant="h6" component="div">
                    Checkmark
                  </Typography>
                </Item>
              </Stack>
            </Grid>
          )}

          <Grid
            item
            xs={signType === "sender" ? 8 : 11}
            sx={{ borderTop: "1px solid #ccc", borderBottom: "1px solid #ccc" }}
            id="mainGrid"
          >
            <div
              className="parent"
              style={{
                maxHeight: `${parseInt(pdfCanvasHeight) + 50}px`,
                overflow: "auto",
              }}
            >
              <Document
                file={file}
                onLoadSuccess={handlePDFLoadSuccess}
                onDocumentComplete={onDocumentLoadSuccess}
                onLoadError={() => {
                  console.log("CALLED");
                }}
                onLoadProgress={() => {
                  console.log("PRGREOSS");
                }}
              >
                {Array.from(new Array(numPages), (el, index) => (
                  <PageWithObserver
                    key={`page_${index + 1}`}
                    pageNumber={index + 1}
                    setPageVisibility={setPageVisibility}
                  />
                ))}
              </Document>
            </div>
          </Grid>

          <Grid item xs={1} sx={{ border: "1px solid #ccc", p: 2 }}>
            <ButtonGroup
              orientation="vertical"
              aria-label="vertical outlined button group"
            >
              {getPageDocumentPage()}
            </ButtonGroup>
          </Grid>
        </Grid>

        <SignPopup
          open={open}
          handleClose={handleClose}
          handleSaveSign={handleSaveSign}
          handleSaveDate={handleSaveDate}
          selectedObj={selectedObj}
        />
      </Container>
    </>
  );
}
